
const LOG_BUFFER_MAX = 300;
const LOG_DUMP_DEFAULT = 100;
window.__origLog = console.log.bind(console);
window.__logBuffer = [];

try {
    console.log = function(...args) {
        const msg = args.map(a => {
            try { return typeof a === 'object' ? JSON.stringify(a) : String(a); }
            catch (e) { return String(a); }
        }).join(' ');
        const ts = new Date().toISOString().slice(11, 23);
        const entry = `[${ts}] ${msg}`;

        window.__logBuffer.push(entry);
        if (window.__logBuffer.length > LOG_BUFFER_MAX) {
            window.__logBuffer.shift();
        }

        window.__origLog.apply(console, args);

        // 네이티브 로그로 전달 (Action 100 → Xcode/Logcat)
        try {
            const payload = JSON.stringify({ action: 100, bridgeParam: { msg: entry, title: 'Log' } });
            if (window.webkit?.messageHandlers?.bridgeMessageHandler) {
                window.webkit.messageHandlers.bridgeMessageHandler.postMessage(payload);
            } else if (window.bridgeMessageHandler) {
                window.bridgeMessageHandler.messageHandler(payload);
            }
        } catch (e) {}
    };
} catch (e) {
    window.__origLog('console.log override failed:', e);
}

// 인스펙터 연결 후 호출
// window.dumpLogs()      → 최근 100개 출력
// window.dumpLogs("all") → 전체 버퍼 출력
window.dumpLogs = function(mode) {
    const logs = mode === 'all'
        ? window.__logBuffer
        : window.__logBuffer.slice(-LOG_DUMP_DEFAULT);
    logs.forEach(l => window.__origLog(l));
    return logs.join('\n');
};
